export const articleQuestions = [
  {
    id: 1,
    koreanQuestion:
      "설립된 2008년에, Innovate Solutions (현재) 개발했다 AI 애플리케이션을 그.. 사용되는 산업에서 금융, 의료, 물류같은",
    question:
      "Founded in 2008, Innovate Solutions has developed AI applications used _____ industries such as finance, healthcare, and logistics.",
    choices: {
      A: "on",
      B: "at",
      C: "in",
      D: "to",
    },
    correctAnswer: "C",
    explanation:
      'in industries: 특정 산업 내에서 사용된다는 의미이므로 "in"이 적절한 전치사입니다. (A) on: 표면적 위치, 주제에 사용되나 여기선 어색합니다. (B) at: 장소나 지점을 말할 때 사용됩니다. (D) to: 방향이나 대상 표현이지만 산업과는 어울리지 않습니다.',
    translation:
      "2008년에 설립된 Innovate Solutions는 금융, 의료, 물류와 같은 산업에서 사용되는 AI 애플리케이션을 개발했습니다.",
    type: "article",
  },

  {
    id: 2,
    koreanQuestion:
      "스마트워치는 또한 갖추고 있습니다 음성 활성화 AI 지원을, 할 수 있게 하며 사용자가 관리하도록 스케줄을, 보내도록 메시지를, 그리고 조절하도록 스마트홈 장치들을 _______ ",
    question:
      "The smartwatch is also equipped with voice-activated AI assistance, enabling users to manage schedules, send messages, and control smart home devices _____.",
    choices: {
      A: "effortlessly",
      B: "roughly",
      C: "loudly",
      D: "carelessly",
    },
    correctAnswer: "A",
    explanation:
      'effortlessly: "아무런 노력 없이, 쉽게"라는 뜻으로 AI의 편리함을 강조하는 문맥에 가장 자연스럽습니다. (B) roughly: 거칠게 (C) loudly: 시끄럽게 (D) carelessly: 부주의하게 → 모두 문맥상 어울리지 않음',
    translation:
      "스마트워치는 또한 음성 활성화 AI 지원 기능을 갖추고 있어 사용자가 일정을 관리하고, 메시지를 보내고, 스마트 홈 기기를 쉽게 제어할 수 있게 합니다.",
    type: "article",
  },
  {
    id: 3,
    koreanQuestion:
      "중앙은행은 발표했습니다 중앙은행은 ______ 금리를 0.25% 다음 분기에",
    question:
      "The central bank announced it would ______ interest rates by 0.25% next quarter.",
    choices: {
      A: "raise",
      B: "raised",
      C: "raising",
      D: "raises",
    },
    correctAnswer: "A",
    explanation:
      'raise: "would" 조동사 뒤에는 동사 원형이 와야 합니다. (A) raise: 동사 원형 (B) raised: 과거형 (C) raising: 현재분사 (D) raises: 3인칭 단수 현재형 → would 뒤에는 동사 원형만 올 수 있습니다.',
    translation:
      "중앙은행은 다음 분기에 금리를 0.25% 인상할 것이라고 발표했습니다.",
    type: "article",
  },
  {
    id: 4,
    koreanQuestion:
      "SwiftCargo, 선도적인 글로벌 물류 제공업체는, (현재) 발표했습니다 확장을 유럽 시장으로, 개설하며 지역 사무소를 독일, 프랑스, 그리고 네덜란드에.",
    question:
      "SwiftCargo, a leading global logistics provider, has announced its expansion _____ the European market, opening regional offices in Germany, France, and the Netherlands.",
    choices: {
      A: "onto",
      B: "for",
      C: "into",
      D: "by",
    },
    correctAnswer: "C",
    explanation:
      'into: "~로 들어가다"라는 의미로 새로운 시장에 진출한다는 맥락에 가장 적합합니다. (A) onto: 표면 위로 이동할 때 사용되며 시장 진출에는 부적절합니다. (B) for: 목적이나 대상을 나타내지만 시장 진입의 방향성을 표현하기에는 부족합니다. (D) by: 수단이나 방법을 나타내는 전치사로 시장 확장 맥락과 맞지 않습니다.',
    translation:
      "SwiftCargo, 선도적인 글로벌 물류 제공업체는 독일, 프랑스, 네덜란드에 지역 사무소를 개설하며 유럽 시장으로의 확장을 발표했습니다.",
    type: "article",
  },
  {
    id: 5,
    koreanQuestion:
      "이 투자는 재확인합니다 우리의 약속을 지속가능성에 대한 그리고 제공할 것입니다 깨끗한, _____ 에너지를 수백만 가구에",
    question:
      "This investment reaffirms our commitment to sustainability and will provide clean, _____ energy to millions of homes.",
    choices: {
      A: "dangerous",
      B: "expensive",
      C: "affordable",
      D: "harmful",
    },
    correctAnswer: "C",
    explanation:
      'affordable: "적당한 가격의, 감당할 수 있는"이라는 뜻으로, clean energy와 함께 긍정적인 문맥에 가장 자연스럽게 어울림 (A) dangerous: "위험한" → clean energy와 반대 의미 (B) expensive: 비싸다는 의미로 문맥상 부정적 (D) harmful: "해로운" → clean/sustainable과 반대 의미',
    translation:
      "이 투자는 지속 가능성에 대한 우리의 약속을 재확인하며, 수백만 가구에 깨끗하고 저렴한 에너지를 제공할 것입니다.",
    type: "article",
  },
  {
    id: 6,
    koreanQuestion: "건설은 첫 번째 시설 예정이다 시작될 2026년 초에",
    question:
      "The construction of the first facility is set to begin _____ early 2026.",
    choices: {
      A: "on",
      B: "at",
      C: "in",
      D: "by",
    },
    correctAnswer: "C",
    explanation:
      'in: 연도나 계절, 월과 같은 더 넓은 시간 범위를 나타낼 때 "in"을 사용합니다. "early 2026"은 2026년 초라는 기간을 나타내므로 "in"이 적절합니다. (A) on: 특정 날짜나 요일에 사용됩니다. (B) at: 특정 시간이나 시점에 사용됩니다. (D) by: "~까지"라는 의미로 마감 시간을 나타낼 때 사용됩니다.',
    translation: "첫 번째 시설의 건설은 2026년 초에 시작될 예정입니다.",
    type: "article",
  },
  {
    id: 7,
    koreanQuestion:
      "새로운 대중교통 시스템은 기대된다 줄일것을 혼잡을, 향상시킬것을 매일의 ___ , 그리고 지원할 것으로 경제 성장을 주변지역의 ",
    question:
      "The new transit system is expected to reduce congestion, improve daily _____, and support economic growth in surrounding areas.",
    choices: {
      A: "requests",
      B: "deliveries",
      C: "commutes",
      D: "machines",
    },
    correctAnswer: "C",
    explanation:
      "commutes: 출퇴근, 통근이라는 의미로, daily와 함께 쓰일 때 가장 자연스러움 (A) requests: 요청들 → 통근과 관련 없음 (B) deliveries: 배달들 → 의미가 다름 (D) machines: 기계들 → 문맥에 맞지 않음",
    translation:
      "새로운 대중교통 시스템은 혼잡을 줄이고, 일상적인 통근을 개선하며, 주변 지역의 경제 성장을 지원할 것으로 예상됩니다.",
    type: "article",
  },
  {
    id: 8,
    koreanQuestion:
      "2년 후 공사, Grand Central Library는 (현재) _____ 열었다 이것의 문을, 제공하며 최첨단 시설을 거주자를 위해 그리고 학생들을 위해 ",
    question:
      "After two years of construction, the Grand Central Library has _____ opened its doors, offering a state-of-the-art facility for residents and students.",
    choices: {
      A: "rarely",
      B: "officially",
      C: "accidentally",
      D: "temporarily",
    },
    correctAnswer: "B",
    explanation:
      'officially: 공적으로, 공식적으로 → 기관, 시설 등의 개장을 나타낼 때 자연스러운 표현 (A) rarely: 거의 ~하지 않다 → 개장과 어울리지 않음 (C) accidentally: 우연히 → 문맥상 부적절 (D) temporarily: 일시적으로 → "opened"를 수식하면 어색함',
    translation:
      "2년간의 공사 후, 그랜드 센트럴 도서관은 주민들과 학생들을 위한 최첨단 시설을 제공하며 공식적으로 문을 열었습니다.",
    type: "article",
  },
  {
    id: 9,
    koreanQuestion:
      "Grand Foods는, 하나 국내에서 최대 식료품 소매업체들 중, (현재) 확정했다 ____ 인수를 FreshHarvest Markets의, 그.. 지역 수퍼마켓 체인 알려진 유기농과 지역 소싱 제품에",
    question:
      "Grand Foods, one of the largest grocery retailers in the country, has finalized _____ acquisition of FreshHarvest Markets, a regional supermarket chain known for its focus on organic and locally sourced products.",
    choices: {
      A: "their",
      B: "it",
      C: "its",
      D: "this",
    },
    correctAnswer: "C",
    explanation:
      "its: Grand Foods는 단수 회사이므로, 단수 소유격 its가 정답입니다. (A) their: 복수 소유격, 사람이나 복수 회사에 씀 (B) it: 주격 대명사로 소유격 자리에 쓸 수 없음 (D) this: 지시대명사로, 소유의 의미를 나타내지 못함",
    translation:
      "국내 최대 식료품 소매업체 중 하나인 Grand Foods는 유기농과 지역 소싱 제품에 중점을 둔 것으로 알려진 지역 슈퍼마켓 체인인 FreshHarvest Markets의 인수를 확정했습니다.",
    type: "article",
  },
  {
    id: 10,
    koreanQuestion:
      "회사의 분기 보고서는 보여주었다 _____ 증가를 수익에 있어서 시장 변동성에도.",
    question:
      "The company's quarterly report showed a ______ increase in revenue despite market volatility.",
    choices: {
      A: "slight",
      B: "slightly",
      C: "slighter",
      D: "slights",
    },
    correctAnswer: "A",
    explanation:
      "A: slight: '약간의'라는 의미의 형용사로 명사를 수식합니다. 'a slight increase'는 '약간의 증가'라는 의미로 문법적으로 올바릅니다. B: slightly: 부사로 동사나 형용사를 수식하므로 명사 앞에 사용할 수 없습니다. C: slighter: 비교급 형태로 문맥에 맞지 않습니다. D: slights: 동사 또는 복수 명사 형태로 문맥에 맞지 않습니다.",
    translation:
      "회사의 분기 보고서는 시장 변동성에도 불구하고 수익에 약간의 증가를 보여주었습니다.",
    type: "article",
  },
  {
    id: 11,
    koreanQuestion:
      "당국은 경고했습니다 대중에게 ______  사기성 이메일에 대해 주장하는 온것이라고 공식 출처에서",
    question:
      "Authorities warned the public to ______ against fraudulent emails claiming to be from official sources.",
    choices: {
      A: "beware",
      B: "alert",
      C: "protect",
      D: "caution",
    },
    correctAnswer: "A",
    explanation:
      "beware: '조심하다, 주의하다'라는 의미로 'beware of/against'는 '~에 대해 주의하다'라는 표현입니다. (B) alert: '경계하다'라는 의미의 동사지만 여기서는 문법적으로 맞지 않음 (C) protect: '보호하다'는 타동사로 목적어가 필요하며 문맥에 맞지 않음 (D) caution: 명사 또는 동사로 쓰이나 여기서는 구문상 부적절",
    translation:
      "당국은 공식 출처에서 온 것이라고 주장하는 사기성 이메일에 대해 주의하라고 대중에게 경고했습니다.",
    type: "article",
  },
  {
    id: 12,
    koreanQuestion:
      "연구 센터는 시작했습니다 _____을 연구하기 위해 영향을 원격 근무가 미치는 생산성에.",
    question:
      "The research center launched a ______ to study the impact of remote work on productivity.",
    choices: {
      A: "program",
      B: "programming",
      C: "programmed",
      D: "programmer",
    },
    correctAnswer: "A",
    explanation:
      'program: "프로그램"이라는 명사로, 연구 센터가 시작한 것을 나타내는 데 적합합니다. (B) programming: 프로그래밍(동명사/행위) (C) programmed: 프로그램된(과거분사) (D) programmer: 프로그래머(사람)로 문맥에 맞지 않음',
    translation:
      "연구 센터는 원격 근무가 생산성에 미치는 영향을 연구하기 위한 프로그램을 시작했습니다.",
    type: "article",
  },
  {
    id: 13,
    koreanQuestion:
      "소비자들은 ____ 선택하는 중이다 월간 혹은 연간 구독 서비스를 모든 것들을 위해 식료품으로부터 그리고 의류, 개인 관리 제품까지 그리고 엔터테인먼트",
    question:
      "Consumers are _____ opting for monthly or annual subscription services for everything from groceries and clothing to personal care products and entertainment.",
    choices: {
      A: "suddenly",
      B: "increasingly",
      C: "rarely",
      D: "loudly",
    },
    correctAnswer: "B",
    explanation:
      '(A) suddenly: "갑자기" → 문맥상 점진적인 변화를 설명하고 있어서 부적절합니다. (B) increasingly: "점점 더, 갈수록" → 현재 소비 트렌드의 변화를 자연스럽게 설명하는 정답입니다. (C) rarely: "거의 ~하지 않는다" → 문장의 의미와 반대되어 부적절합니다. (D) loudly: "시끄럽게" → 선택의 빈도나 정도가 아닌 동작의 방법을 설명하므로 문맥에 맞지 않습니다.',
    translation:
      "소비자들은 점점 더 식료품과 의류부터 개인 관리 제품 및 엔터테인먼트에 이르기까지 모든 것에 대해 월간 또는 연간 구독 서비스를 선택하고 있습니다.",
    type: "article",
  },
  {
    id: 14,
    koreanQuestion:
      "쇼핑객들은 할 수 있을 것이다 스캔을 아이템들을 그들의 스마트폰과 함께 그리고 지불할 수 있을 것이다 ____, 제거하며 필요를 전통적 계산대 줄을",
    question:
      "Shoppers will be able to scan items with their smartphones and pay _____, eliminating the need for traditional checkout lines.",
    choices: {
      A: "rarely",
      B: "instantly",
      C: "slowly",
      D: "loudly",
    },
    correctAnswer: "B",
    explanation:
      '(A) rarely: "거의 ~하지 않다" → 문맥과 반대되어 부적절합니다. (B) instantly: "즉시, 즉각적으로" → 편리하고 빠른 결제 시스템을 설명하는 데 가장 적절한 부사입니다. (C) slowly: "느리게" → 문장의 빠르고 효율적인 흐름과 맞지 않습니다. (D) loudly: "소리 크게" → 결제 방식과 관련 없는 의미로 부적절합니다.',
    translation:
      "쇼핑객들은 스마트폰으로 상품을 스캔하고 즉시 결제할 수 있게 되어, 전통적인 계산대 줄을 기다릴 필요가 없어질 것입니다.",
    type: "article",
  },
  {
    id: 15,
    koreanQuestion:
      "관계자들은 예상한다 첫번째 단계 심는것 완료되기를 내년초____, 지속적인 모니터링과 함께 보장하기 위해서 나무 생존 그리고 장기적인 환경적 이점들",
    question:
      "Officials expect the first phase of planting to be completed _____ early next year, with continuous monitoring to ensure tree survival and long-term environmental benefits.",
    choices: {
      A: "at",
      B: "during",
      C: "by",
      D: "over",
    },
    correctAnswer: "C",
    explanation:
      'by: "~까지" → 기한 내 완료 예정을 나타낼 때 사용하는 전치사 (A) at: 특정 시각엔 적절하지만 "기한"에는 부적절 (B) during: 어떤 기간 중에, 완료 시점과는 어울리지 않음 (D) over: "기간 동안"이라는 의미로 완료 시점과는 다름',
    translation:
      "관계자들은 나무의 생존과 장기적인 환경적 이점을 보장하기 위한 지속적인 모니터링과 함께, 식목의 첫 번째 단계가 내년 초까지 완료될 것으로 예상합니다.",
    type: "article",
  },
  {
    id: 16,
    koreanQuestion:
      "그는 더 설명했다 그.. 도시가 제공할 것이라고 보조금을 주택소유자들에게 그... 심는 나무들을 그들의 부지에, 그들이 유지한다는 조건하에 나무들을 적어도 2년동안",
    question:
      "He further explained that the city will provide subsidies for homeowners _____ plant trees on their properties, provided they maintain them for at least two years.",
    choices: {
      A: "which",
      B: "where",
      C: "who",
      D: "when",
    },
    correctAnswer: "C",
    explanation:
      'who: "~하는" → 사람(homeowners)을 수식하는 주격 관계대명사로 적절함 (A) which: 사물에 쓰는 관계대명사로 사람(homeowners)에 부적절 (B) where: 장소를 나타내는 관계부사로 문맥에 맞지 않음 (D) when: 시간 표현과 함께 써야 자연스러운 관계부사',
    translation:
      "그는 주택 소유자들이 최소 2년 동안 나무를 관리한다는 조건 하에, 자신의 부지에 나무를 심는 주택 소유자들에게 도시가 보조금을 제공할 것이라고 추가로 설명했습니다.",
    type: "article",
  },
  {
    id: 17,
    koreanQuestion:
      "레이크사이드 시의회는 (현재) 발표했다 대규모 홍수 예방 계획을 그.. 목표로 하는 보호하는것을 주민들을 그리고 사업을 반복되는 계절성 홍수로부터",
    question:
      "The Lakeside City Council has unveiled a large-scale flood prevention initiative aimed _____ protecting residents and businesses from recurring seasonal floods.",
    choices: {
      A: "for",
      B: "at",
      C: "on",
      D: "by",
    },
    correctAnswer: "B",
    explanation:
      'at: "aimed at + 명사/동명사: ~을 목표로 한"이라는 고정 표현 (A) for: 목적 대상 표현으로 혼동 가능하지만 이 구조에서는 틀림 (C) on: 주제에는 쓰이지만 aim과는 결합하지 않음 (D) by: 행위자를 나타내는 전치사로 어울리지 않음',
    translation:
      "레이크사이드 시의회는 주민들과 사업체들을 반복되는 계절성 홍수로부터 보호하는 것을 목표로 하는 대규모 홍수 예방 계획을 발표했습니다.",
    type: "article",
  },
  {
    id: 18,
    koreanQuestion:
      "_____ 많은 강우량 그리고 노후화된 인프라가 (현재) 초래했다 심각한 홍수 피해를 최근 몇년간",
    question:
      "_____ heavy rainfall and outdated infrastructure have led to severe flood damage in recent years.",
    choices: {
      A: "Loudly",
      B: "Unusually",
      C: "Barely",
      D: "Quickly",
    },
    correctAnswer: "B",
    explanation:
      '(B) Unusually: "이례적으로" → heavy rainfall을 수식하며 자연스러운 표현 (A) Loudly: "시끄럽게" → 비와 관련 없음 (C) Barely: "거의 ~않게" → 부정적 의미로 문맥상 맞지 않음 (D) Quickly: "빠르게" → 홍수 피해와 어울리지 않음',
    translation:
      "이례적으로 많은 강우량과 노후화된 인프라가 최근 몇 년간 심각한 홍수 피해를 초래했습니다.",
    type: "article",
  },
  {
    id: 19,
    koreanQuestion:
      "이 계획은 목표로 한다 _____ 배출량을, 확장하며 녹지공간을, 그리고 장려하며 지속가능한 관행을 주요 도시에서",
    question:
      "The initiative aims _____ emissions, expand green spaces, and encourage sustainable practices in major cities.",
    choices: {
      A: "reducing",
      B: "reduced",
      C: "to reduce",
      D: "reduction",
    },
    correctAnswer: "C",
    explanation:
      '(C) to reduce: "aims to + 동사원형: ~하는 것을 목표로 하다" → 정해진 표현 (A) reducing: 동명사 → 전치사 목적어 자리는 아니므로 틀림 (B) reduced: 과거분사 → 문장 구조상 어울리지 않음 (D) reduction: 명사 → 동사 자리에는 올 수 없음',
    translation:
      "이 계획은 배출량을 줄이고, 녹지 공간을 확장하며, 주요 도시에서 지속 가능한 관행을 장려하는 것을 목표로 합니다.",
    type: "article",
  },
  {
    id: 20,
    koreanQuestion:
      "우리는 _____ 믿는다 그.. 모든 한 푼이 중요하다 우리의 사명에서 만들기 위해 긍정적인 변화를",
    question:
      "We _____ believe that every cent counts in our mission to create positive change.",
    choices: {
      A: "rarely",
      B: "firmly",
      C: "accidentally",
      D: "briefly",
    },
    correctAnswer: "B",
    explanation:
      '(B) firmly: "확고하게, 굳게" → 신념을 나타내는 believe와 자주 쓰이는 조합 (firmly believe) (A) rarely: "거의 ~하지 않다" → 문장 내용과 모순됨 (C) accidentally: "우연히" → 믿음과는 무관 (D) briefly: "잠시, 간단히" → 믿음과는 의미상 어울리지 않음',
    translation:
      "우리는 긍정적인 변화를 만드는 우리의 사명에서 모든 한 푼이 중요하다는 것을 확고하게 믿습니다.",
    type: "article",
  },
  {
    id: 21,
    koreanQuestion:
      "마케팅 팀은 시작했다 ____를 높이기 위해 브랜드 인지도를 해외 고객들 사이에서",
    question:
      "The marketing team launched a ______ to raise brand awareness among overseas customers.",
    choices: {
      A: "campaign",
      B: "campaigning",
      C: "campaigned",
      D: "campaigner",
    },
    correctAnswer: "A",
    explanation:
      '(A) campaign: "캠페인" → 명사로 a 다음에 명사가 와야 함 (B) campaigning: 동명사 → 관사 a 뒤에 올 수 없음 (C) campaigned: 과거분사 → 관사 a 뒤에 올 수 없음 (D) campaigner: "운동가" → 문맥상 맞지 않음',
    translation:
      "마케팅 팀은 해외 고객들 사이에서 브랜드 인지도를 높이기 위해 캠페인을 시작했다.",
    type: "article",
  },
  {
    id: 22,
    koreanQuestion:
      "새로운 임명은 반영한다 우리의 헌신과 비전을 확립하며 새로운 기준을 우수성의 조직 내에서 ",
    question:
      "The new appointment reflects our commitment and vision _____ establishing a new standard of excellence in the organization.",
    choices: {
      A: "under",
      B: "over",
      C: "toward",
      D: "behind",
    },
    correctAnswer: "C",
    explanation:
      '(C) toward: "~을 향한"이라는 의미로, commitment and vision의 방향성을 나타낼 때 적절한 전치사 (A) under: "~하에"라는 뜻으로, 통제나 조건과 관련 → 의미 불일치 (B) over: "~에 대해, ~위에" → 이 문맥에서는 부적절 (D) behind: "~뒤에" → 물리적/시간적 위치에 사용 → 문맥상 어색',
    translation:
      "새로운 임명은 조직 내에서 새로운 우수성의 기준을 확립하는 것을 향한 우리의 헌신과 비전을 반영합니다.",
    type: "article",
  },
  {
    id: 23,
    koreanQuestion:
      "경험이 풍부한 인사 전문가로서 입증된 실적을 가진, Kathy Glass는 핵심적일 것이다 강화시키는데 우리의 프레임워크를 그리고 _____ 부서의 전략적 역할을 회사와 함께",
    question:
      "As an experienced HR professional with a proven track record, Kathy Glass will be instrumental in strengthening our framework and _____ the department's strategic role within the company.",
    choices: {
      A: "evolve",
      B: "evolved",
      C: "evolving",
      D: "evolves",
    },
    correctAnswer: "C",
    explanation:
      "(C) evolving: 전치사 in 다음에는 동명사(V-ing)가 와야 하고, strengthening과 evolving은 병렬 구조를 이루므로 형태가 같아야 함 (A) evolve: 동사원형 → 전치사 뒤에 올 수 없음 (B) evolved: 과거분사 → 문맥상 맞지 않음 (D) evolves: 현재형 동사 → 문법 오류",
    translation:
      "경험이 풍부한 인사 전문가로서 입증된 실적을 가진 Kathy Glass는 우리의 프레임워크를 강화하고 회사 내에서 부서의 전략적 역할을 발전시키는 데 중요한 역할을 할 것입니다.",
    type: "article",
  },
  {
    id: 24,
    koreanQuestion:
      "그들의 주요 초점은 개발하는 것이 될것이다 그리고 구현하는 것 HR 전략을 그...부합하는 회사의 전반적인 사명과 그리고 비전을.",
    question:
      "Their primary focus will be developing and implementing HR strategies that align _____ the company's overall mission and vision.",
    choices: {
      A: "on",
      B: "at",
      C: "with",
      D: "by",
    },
    correctAnswer: "C",
    explanation:
      '(C) with: "~와 일치하다, 부합하다"라는 뜻의 고정 표현 (A) on: 주제 표현엔 쓰이지만 align과는 어울리지 않음 (B) at: 지점/방향 표현에 주로 사용됨 (D) by: 수단, 행위자 표현으로 문맥에 맞지 않음',
    translation:
      "그들의 주요 초점은 회사의 전반적인 사명과 비전에 부합하는 인사 전략을 개발하고 구현하는 것이 될 것입니다.",
    type: "article",
  },

  {
    id: 25,
    koreanQuestion:
      "회사는 시작했습니다 ____ 를 향상시키기 위해 직원 만족도를 부서 전반에 걸쳐.",
    question:
      "The firm launched an ______ to improve employee satisfaction across departments.",
    choices: {
      A: "initiative",
      B: "initiate",
      C: "initiated",
      D: "initiator",
    },
    correctAnswer: "A",
    explanation:
      '(A) initiative: "계획, 주도권"이라는 의미의 명사로, 문맥상 회사가 시작한 계획을 의미함 (B) initiate: 동사형태로 명사가 필요한 자리에 부적절 (C) initiated: 과거분사 형태로 명사가 필요한 자리에 부적절 (D) initiator: "주도자, 발의자"라는 의미의 명사로 문맥상 부적절',
    translation:
      "회사는 부서 전반에 걸쳐 직원 만족도를 향상시키기 위한 계획을 시작했습니다.",
    type: "article",
  },
  {
    id: 26,
    koreanQuestion:
      "_____ 농구, 있을 것입니다 음식 판매자, 경품 추첨, 그리고 가족 친화적 활동들이 하루 종일",
    question:
      "_____ basketball, there will be food vendors, raffles, and family-friendly activities throughout the day.",
    choices: {
      A: "Because of",
      B: "Despite",
      C: "In addition to",
      D: "Instead",
    },
    correctAnswer: "C",
    explanation:
      '(C) In addition to: "~에 더하여" → 추가 정보를 나타내는 자연스러운 표현 (A) Because of: "~때문에" → 이유를 나타내며 문맥과 어울리지 않음 (B) Despite: "~에도 불구하고" → 대조/역접 의미로 부적절 (D) Instead: 부사로 쓰이며 전치사처럼 명사를 직접 이끌 수 없음',
    translation:
      "농구에 더하여, 하루 종일 음식 판매자, 경품 추첨, 그리고 가족 친화적인 활동들이 있을 것입니다.",
    type: "article",
  },
  {
    id: 27,
    koreanQuestion:
      "모든 _____ 행사로부터의 직접적으로 지원할 것입니다 젊은 운동선수들을 그리고 도울 것입니다 만드는 것을 스포츠를 더 접근하기 쉽게 모두를 위해",
    question:
      "All _____ from the event will directly support young athletes and help make sports more accessible for everyone.",
    choices: {
      A: "details",
      B: "requests",
      C: "programs",
      D: "proceeds",
    },
    correctAnswer: "D",
    explanation:
      '(D) proceeds: "수익금, 수입" → 자선 행사나 이벤트 수익과 관련된 전형적인 표현 (A) details: 세부 사항 → 문맥상 어울리지 않음 (B) requests: 요청들 → 지원의 원천이 될 수 없으므로 부적절 (C) programs: 행사 내용 자체를 의미 → 수익과는 관련 없음',
    translation:
      "행사로부터의 모든 수익금은 직접적으로 젊은 운동선수들을 지원하고 모두를 위해 스포츠를 더 접근하기 쉽게 만드는 것을 도울 것입니다.",
    type: "article",
  },
  {
    id: 28,
    koreanQuestion:
      "_______ 이번 출시, 회사는 목표로 합니다 강화하는 것을 회사의 위치를 리더로서 업계 안에서",
    question:
      "_______ this launch, the company aims to strengthen its position as a leader in the industry.",
    choices: {
      A: "Although",
      B: "With",
      C: "Because",
      D: "Despite",
    },
    correctAnswer: "B",
    explanation:
      '(B) With: "~와 함께" → 이번 출시를 통해/이번 출시와 함께라는 의미로 적절함 (A) Although: "비록 ~일지라도" → 이번 출시 불구하고 (C) Because: "~때문에" → 이번 출시 때문에 (D) Despite: "~에도 불구하고" → 이번 출시에도 불구하고',
    translation:
      "이번 출시와 함께, 회사는 업계의 리더로서 자신의 위치를 강화하는 것을 목표로 합니다.",
    type: "article",
  },
  {
    id: 29,
    koreanQuestion:
      "XYZ Corporation 은 _______  이 회사의 최첨단 솔루션과 고객 중심 접근방식으로, 그리고 이 회사의 최근 제품은 예외가 아닙니다",
    question:
      "XYZ Corporation is _______ for its cutting-edge solutions and customer-centric approach, and this latest offering is no exception.",
    choices: {
      A: "renowned",
      B: "distributed",
      C: "manufactured",
      D: "operated",
    },
    correctAnswer: "A",
    explanation:
      '(A) renowned: "유명한" → 문맥상 "XYZ Corporation은 최첨단 솔루션과 고객 중심 접근 방식으로 유명하다"는 의미이므로 적절함 (B) distributed: "유통되다" → 문맥상 어색함 (C) manufactured: "제조되다" → 문맥상 어색함 (D) operated: "운영되다" → 문맥상 어색함',
    translation:
      "XYZ Corporation은 최첨단 솔루션과 고객 중심 접근 방식으로 유명하며, 이번 최신 제품도 예외가 아닙니다.",
    type: "article",
  },
  {
    id: 30,
    koreanQuestion:
      "회사는 시작했습니다 _____을 수집하기 위해 고객 피드백을 새로운 제품 라인에 대한",
    question:
      "The company launched a ______ to gather customer feedback on the new product line.",
    choices: {
      A: "survey",
      B: "surveying",
      C: "surveyed",
      D: "surveyor",
    },
    correctAnswer: "A",
    explanation:
      '(A) survey: "설문조사" → 고객 피드백을 수집하기 위한 도구로 적절함 (B) surveying: "조사하는 것" → 명사가 필요한 자리에 동명사 형태로 부적절 (C) surveyed: "조사된" → 과거분사 형태로 문맥상 부적절 (D) surveyor: "측량사, 조사관" → 사람을 지칭하는 단어로 문맥상 부적절',
    translation:
      "회사는 새로운 제품 라인에 대한 고객 피드백을 수집하기 위해 설문조사를 시작했습니다.",
    type: "article",
  },
  {
    id: 31,
    koreanQuestion:
      "출시는 새로운 제품 강조합니다 XYZ회사의 전념을 ____하는데 경계를 기술의 그리고 탐색하는데 새로운 미개척분야를",
    question:
      "The release of the new product underscores XYZ Corporation's dedication to _______ the boundaries of technology and exploring new frontiers.",
    choices: {
      A: "push",
      B: "pushed",
      C: "pushing",
      D: "to push",
    },
    correctAnswer: "C",
    explanation:
      '(C) pushing: "전치사 to 다음에 동명사 pushing이 와야 합니다. dedication to ~ing은 고정 표현으로, "헌신 / 전념" 뒤에는 동명사가 옵니다. (A) 동사 원형, (B) 과거형, (D) 부정사로 모두 부적절합니다."',
    translation:
      "새 제품 출시는 XYZ Corporation이 기술의 경계를 넓히고 새로운 영역을 탐구하는 데 전념하고 있음을 강조합니다.",
    type: "article",
  },
  {
    id: 32,
    koreanQuestion:
      "국립 디자인 박물관은 초대합니다 모두가 경험하도록 이 혁신적인 전시회를, 그.... 공개하는 대중에 4월 15일에 그리고 진행하는 9월 1일까지 내내 ",
    question:
      "The National Design Museum invites all to experience this transformative exhibition, ______ opens to the public on April 15 and runs through September 1.",
    choices: {
      A: "who",
      B: "which",
      C: "where",
      D: "what",
    },
    correctAnswer: "B",
    explanation:
      '(B) which: "선행사 this transformative exhibition은 사물이므로 관계대명사 which가 적절합니다. (A) who: 사람을 가리키는 관계대명사로 부적절 (C) where: 장소를 가리키는 관계부사로 부적절 (D) what: 선행사를 포함하는 관계대명사로 부적절"',
    translation:
      "국립 디자인 박물관은 모든 사람들을 이 혁신적인 전시회를 경험하도록 초대합니다. 이 전시회는 4월 15일에 대중에 공개되어 9월 1일까지 진행됩니다.",
    type: "article",
  },
  {
    id: 33,
    koreanQuestion:
      "QLink Solutions는 _____ 상위 5개 사이버보안 기업들 업계 내에서.",
    question:
      "QLink Solutions is _____ the top five cybersecurity firms in the industry.",
    choices: {
      A: "around",
      B: "between",
      C: "among",
      D: "inside",
    },
    correctAnswer: "C",
    explanation:
      '(C) among: "셋 이상의 대상 중 하나임을 나타낼 때 among을 사용합니다. 여기서는 5개 기업 중 하나이므로 among이 적절합니다. (A) around: 주변에라는 의미로 부적절 (B) between: 두 대상 사이에 사용하는 전치사로 부적절 (D) inside: 내부에라는 의미로 문맥상 부적절',
    translation:
      "QLink Solutions는 업계 내 상위 5개 사이버보안 기업 중 하나입니다.",
    type: "article",
  },
  {
    id: 34,
    koreanQuestion:
      "국립 디자인 박물관은 초대합니다 모두가 경험하도록 이 혁신적인 전시회를, 그.... 공개하는 대중에 4월 15일에 그리고 진행하는 9월 1일____",
    question:
      "The National Design Museum invites all to experience this transformative exhibition, which opens to the public on April 15 and runs ______ September 1.",
    choices: {
      A: "through",
      B: "behind",
      C: "without",
      D: "despite",
    },
    correctAnswer: "A",
    explanation:
      '(A) through: "through는 ~까지 쭉이라는 의미로 기간 전체를 나타냅니다. 전시회가 9월 1일까지 계속 진행된다는 의미로 적절합니다. (B) behind: ~뒤에라는 장소 개념으로 시간과 무관합니다. (C) without: ~없이라는 의미로 기간 표현과 무관합니다. (D) despite: ~에도 불구하고라는 의미의 전치사로 시간 표현에 사용할 수 없습니다."',
    translation:
      "국립 디자인 박물관은 모든 사람들을 이 혁신적인 전시회를 경험하도록 초대합니다. 이 전시회는 4월 15일에 대중에 공개되어 9월 1일까지 진행됩니다.",
    type: "article",
  },
  {
    id: 35,
    koreanQuestion:
      "자원봉사 팀들은 배포했다 구호물자를 _______ 침수된 지역들 새벽 전에",
    question:
      "Volunteer teams distributed aid _______ the flooded districts before dawn.",
    choices: {
      A: "around",
      B: "between",
      C: "throughout",
      D: "inside",
    },
    correctAnswer: "C",
    explanation:
      '(C) throughout: "throughout는 ~전체에 걸쳐서라는 의미로, 침수된 지역 전체에 구호물자를 배포했다는 의미를 적절하게 표현합니다. (A) around: 주변에라는 의미로 침수 지역 내부가 아닌 주변을 의미해 부적절합니다. (B) between: 두 대상 사이에 사용하는 전치사로 여러 지역에 대한 표현으로 부적절합니다. (D) inside: 내부에라는 의미로 여러 지역 전체를 포괄하는 표현으로는 부적절합니다."',
    translation:
      "자원봉사 팀들은 새벽이 되기 전에 침수된 지역 전체에 걸쳐 구호물자를 배포했습니다.",
    type: "article",
  },
  {
    id: 36,
    koreanQuestion:
      "뛰어난 전시회가 예정이다 공개를 ____ , 약속하며 혁신적인 플랫폼을 업계 전문가들 그리고 열정가들 모두에게",
    question:
      "An exceptional exhibition is set to unveil ______, promising an innovative platform for industry professionals and enthusiasts alike.",
    choices: {
      A: "itself",
      B: "this",
      C: "each",
      D: "those",
    },
    correctAnswer: "A",
    explanation:
      '(A) itself: "unveil itself"는 "스스로를 공개하다"라는 의미로, 전시회가 자체적으로 공개된다는 의미를 적절하게 표현합니다. (B) this: 지시대명사로 문맥상 맞지 않음 (C) each: 각각을 의미하며 문맥에 맞지 않음 (D) those: 복수형 지시대명사로 단수 주어와 일치하지 않음',
    translation:
      "뛰어난 전시회가 자신을 공개할 예정이며, 업계 전문가들과 열정가들 모두에게 혁신적인 플랫폼을 약속합니다.",
    type: "article",
  },
  {
    id: 37,
    koreanQuestion:
      "이 행사는 설계되었다 선보이는 것뿐만 아니라 최첨단 발전을 ______ 하기 위해 놀라운 조화를 협업 그리고 영감의 커뮤니티 내에서",
    question:
      "This event is designed not only to showcase cutting-edge advancements but also ______ a remarkable blend of collaboration and inspiration within the community.",
    choices: {
      A: "fostering",
      B: "to foster",
      C: "fostered",
      D: "fosters",
    },
    correctAnswer: "B",
    explanation:
      '(B) to foster: "not only to showcase... but also to foster"와 같은 병렬 구조가 필요합니다. 부정사(to-부정사) 형태로 병렬 구조를 맞추어야 합니다. (A) fostering: 현재분사 형태로 병렬 구조에 맞지 않습니다. (C) fostered: 과거형으로 문맥과 구조에 맞지 않습니다. (D) fosters: 현재형 동사로 병렬 구조에 맞지 않습니다.',
    translation:
      "이 행사는 최첨단 발전을 선보이는 것뿐만 아니라 커뮤니티 내에서 협업과 영감의 놀라운 조화를 조성하기 위해 설계되었습니다.",
    type: "article",
  },
  {
    id: 38,
    koreanQuestion:
      "시위자들이 모였다 _______ 시청 광장에 요구하기 위해 정책 변화를",
    question:
      "Protesters gathered _______ the city hall plaza to demand policy changes.",
    choices: {
      A: "around",
      B: "between",
      C: "among",
      D: "inside",
    },
    correctAnswer: "A",
    explanation:
      '(A) around: "around"는 "주변에, 둘러싸여"라는 의미로, 시위자들이 시청 광장 주변에 모였다는 의미를 적절하게 표현합니다. (B) between: "사이에"라는 의미로 두 대상 사이의 관계를 나타내므로 여기서는 적절하지 않습니다. (C) among: "~중에, ~사이에"라는 의미로 세 개 이상의 대상 사이에 사용되지만 여기서는 장소를 둘러싼 의미가 필요하므로 부적절합니다. (D) inside: "내부에"라는 의미로 시위는 보통 광장 내부보다는 주변에서 이루어지므로 문맥상 덜 적절합니다.',
    translation:
      "시위자들이 정책 변화를 요구하기 위해 시청 광장 주변에 모였습니다.",
    type: "article",
  },
  {
    id: 39,
    koreanQuestion:
      "보안군은 점검했습니다 검문소를 두 국경 통과 지점 사이의 오늘",
    question:
      "Security forces inspected checkpoints _______ the two border crossings today.",
    choices: {
      A: "around",
      B: "between",
      C: "among",
      D: "inside",
    },
    correctAnswer: "B",
    explanation:
      '(B) between: "between"은 "사이에"라는 의미로, 두 국경 통과 지점 사이에 있는 검문소를 점검했다는 의미를 적절하게 표현합니다. (A) around: "주변에"라는 의미로 문맥상 적절하지 않습니다. (C) among: "~중에, ~사이에"라는 의미로 세 개 이상의 대상 사이에 사용되므로 두 개의 국경 통과 지점에는 적절하지 않습니다. (D) inside: "내부에"라는 의미로 검문소가 국경 통과 지점 내부에 있다는 의미가 되어 문맥상 적절하지 않습니다.',
    translation:
      "보안군은 오늘 두 국경 통과 지점 사이의 검문소를 점검했습니다.",
    type: "article",
  },
  {
    id: 40,
    koreanQuestion: "응급 서비스가 도착했습니다 10분 이내에",
    question: "Emergency services arrived ____ less than ten minutes.",
    choices: {
      A: "within",
      B: "during",
      C: "for",
      D: "between",
    },
    correctAnswer: "A",
    explanation:
      '(A) within: "within"은 "~이내에"라는 의미로, 특정 시간 범위 안에 일어난 일을 표현할 때 사용합니다. 응급 서비스가 10분이 되기 전에 도착했다는 의미를 정확히 전달합니다. (B) during: "~동안"이라는 의미로, 어떤 기간 내내 지속되는 행동을 표현할 때 사용하므로 여기서는 적절하지 않습니다. (C) for: "~동안"이라는 의미로, 행동이 지속된 기간을 나타내므로 여기서는 적절하지 않습니다. (D) between: "~사이에"라는 의미로, 두 시점 사이를 나타내므로 여기서는 적절하지 않습니다.',
    translation: "응급 서비스가 10분 이내에 도착했습니다.",
    type: "article",
  },
  {
    id: 41,
    koreanQuestion:
      "새로운 철도 노선은 연결할 것입니다 수도를 해안 지역과 2025년까지",
    question:
      "The new rail line will connect the capital ____ the coastal regions by 2025.",
    choices: {
      A: "between",
      B: "to",
      C: "with",
      D: "at",
    },
    correctAnswer: "B",
    explanation:
      '(A) between: "사이에"라는 의미로 두 지점을 연결하는 상황에서는 적절하지 않습니다. (B) to: "~에"라는 의미로 "connect A to B"(A를 B에 연결하다)라는 구조에 가장 적합합니다. (C) with: "~와 함께"라는 의미로 연결 관계를 표현하는 데 적절하지 않습니다. (D) at: "~에서"라는 의미로 연결 관계를 표현하는 데 적절하지 않습니다.',
    translation:
      "새로운 철도 노선은 2025년까지 수도를 해안 지역에 연결할 것입니다.",
    type: "article",
  },
  {
    id: 42,
    koreanQuestion:
      "GreenCity 폐기물 관리는 (현재) 발표했습니다 업데이트를 시 전체 재활용 정책에 대한, ____ 4월 1일부터, 2025년",
    question:
      "GreenCity Waste Management has announced updates to its citywide recycling policy, ______ starting April 1, 2025.",
    choices: {
      A: "available",
      B: "official",
      C: "effective",
      D: "useful",
    },
    correctAnswer: "C",
    explanation:
      '(A) available: "이용 가능한"이라는 의미로 문맥상 정책의 시행을 표현하는 데 적절하지 않습니다. (B) official: "공식적인"이라는 의미로 정책의 시행 시점을 표현하기에 적합하지 않습니다. (C) effective: "발효되는, 시행되는"이라는 의미로 정책이 특정 날짜부터 시행됨을 나타내는 데 가장 적절합니다. (D) useful: "유용한"이라는 의미로 정책의 시행 시점을 표현하는 데 부적절합니다.',
    translation:
      "GreenCity 폐기물 관리는 2025년 4월 1일부터 시행되는 시 전체 재활용 정책에 대한 업데이트를 발표했습니다.",
    type: "article",
  },
  {
    id: 43,
    koreanQuestion:
      "인플레이션은 상승했습니다 ____ 3% 첫 분기에, 촉발시키며 긴급한 조치를 중앙은행으로부터",
    question:
      "Inflation rose ____ 3% in the first quarter, prompting urgent action from the central bank.",
    choices: {
      A: "by",
      B: "to",
      C: "at",
      D: "on",
    },
    correctAnswer: "B",
    explanation:
      '(A) by: "~만큼"이라는 의미로 증가량을 나타내지만, 여기서는 최종 수치를 나타내므로 적절하지 않습니다. (B) to: "~까지"라는 의미로 최종 도달 수치를 나타내는 데 가장 적합합니다. (C) at: "~에서"라는 의미로 특정 지점을 나타내지만, 상승의 결과를 표현하기에 적절하지 않습니다. (D) on: "~에"라는 의미로 상승의 결과를 표현하는 데 적절하지 않습니다.',
    translation:
      "인플레이션은 첫 분기에 3%까지 상승했으며, 이는 중앙은행의 긴급 조치를 촉발시켰습니다.",
    type: "article",
  },
  {
    id: 44,
    koreanQuestion:
      "______ 개정된 지침, 주민들은 이제 요구됩니다 분리하도록 재활용품을 세 가지 별도의 카테고리로 : 종이 제품, 플라스틱 및 금속, 그리고 유리.",
    question:
      "______ the revised guidelines, residents are now required to separate recyclables into three distinct categories: paper products, plastics and metals, and glass.",
    choices: {
      A: "Under",
      B: "Without",
      C: "Across",
      D: "Beyond",
    },
    correctAnswer: "A",
    explanation:
      '(A) Under: "~에 따라"라는 의미로, 규정이나 지침에 따라 행동할 때 사용하는 표현으로 가장 적절합니다. (B) Without: "~없이"라는 의미로 문맥상 어울리지 않습니다. (C) Across: "~을 가로질러"라는 공간적 의미로 지침과 관련이 없습니다. (D) Beyond: "~을 넘어서"라는 의미로 문맥상 어색합니다.',
    translation:
      "개정된 지침에 따라, 주민들은 이제 재활용품을 세 가지 별도의 카테고리로 분류해야 합니다: 종이 제품, 플라스틱 및 금속, 그리고 유리.",
    type: "article",
  },
  {
    id: 45,
    koreanQuestion:
      "이러한 변화들은 시행될 것이다 2025년 3월 28일부터, 그리고 예상됩니다 유지될 것으로 2025년 5월 15일까지",
    question:
      "These changes will take effect beginning March 28, 2025, and are expected to remain in place ______ May 15, 2025.",
    choices: {
      A: "through",
      B: "without",
      C: "above",
      D: "despite",
    },
    correctAnswer: "A",
    explanation:
      '(A) through: "~까지, ~동안"이라는 의미로 기간을 나타내는 데 적절합니다. (B) without: "~없이"라는 의미로 기간 표현에 적합하지 않습니다. (C) above: "~보다 위에"라는 의미로 날짜 범위를 나타내는 데 부적절합니다. (D) despite: "~에도 불구하고"라는 의미로 기간 표현과 관련이 없습니다.',
    translation:
      "이러한 변화들은 2025년 3월 28일부터 시행되며, 2025년 5월 15일까지 유지될 것으로 예상됩니다.",
    type: "article",
  },
  {
    id: 46,
    koreanQuestion:
      "이 기간 동안, 노선 12번, 24번, 37번은 ____ 피하기 위해 메인 도로를 3번가와 7번가 사이의.",
    question:
      "During this period, Routes 12, 24, and 37 will be ______ to avoid Main Street between 3rd Avenue and 7th Avenue.",
    choices: {
      A: "damaged",
      B: "delivered",
      C: "detoured",
      D: "discovered",
    },
    correctAnswer: "C",
    explanation:
      '(A) damaged: "손상되다" - 문맥에 어울리지 않습니다. (B) delivered: "배달되다" - 노선에는 부적절합니다. (C) detoured: "우회되다"라는 의미로, will be + 과거분사 형태의 수동태 구조에서 문맥상 가장 적절합니다. (D) discovered: "발견되다" - 노선과 관련이 없습니다.',
    translation:
      "이 기간 동안, 12번, 24번, 37번 노선은 3번가와 7번가 사이의 메인 스트리트를 피하기 위해 우회될 것입니다.",
    type: "article",
  },
  {
    id: 47,
    koreanQuestion:
      "여러 버스 정류장들이 이 구간을 따라 있는 일시적으로 폐쇄될 것이다, 그리고 승객들은 권장된다 사용하도록 정류장을 Pine Street나 Elm Street의.",
    question:
      "Several bus stops along this stretch will be temporarily closed, and riders are advised to use ______ stops on Pine Street or Elm Street.",
    choices: {
      A: "alternation",
      B: "alternately",
      C: "alternations",
      D: "alternate",
    },
    correctAnswer: "D",
    explanation:
      '(A) alternation: 명사 → 형용사 자리에 쓸 수 없습니다. (B) alternately: 부사 → 명사 stops를 수식할 수 없습니다. (C) alternations: 명사 복수형 → 형용사 자리에는 부적절합니다. (D) alternate: 형용사 → "alternate stops" (대체 정류장들)로 문맥상 가장 적절합니다.',
    translation:
      "이 구간을 따라 있는 여러 버스 정류장들이 일시적으로 폐쇄될 것이며, 승객들은 파인 스트리트나 엘름 스트리트의 대체 정류장을 이용하는 것이 권장됩니다.",
    type: "article",
  },
  {
    id: 48,
    koreanQuestion:
      "그러나, 이러한 조정들은 필요합니다 보장하기 위해 안전을 공사가 진행되는 동안",
    question:
      "However, these adjustments are necessary to ensure safety ___ construction is underway.",
    choices: {
      A: "during",
      B: "because",
      C: "while",
      D: "despite",
    },
    correctAnswer: "C",
    explanation:
      '(A) during: 전치사로 명사와만 함께 쓰이므로 문법적으로 맞지 않습니다. (B) because: 이유를 나타내지만, 의미상 "~동안"이 더 자연스럽습니다. (C) while: "~하는 동안"이라는 뜻의 접속사로, 두 절을 자연스럽게 연결합니다. (D) despite: 전치사이며 "그럼에도 불구하고"라는 뜻으로 문맥에 맞지 않습니다.',
    translation:
      "그러나, 이러한 조정들은 공사가 진행되는 동안 안전을 보장하기 위해 필요합니다.",
    type: "article",
  },

  {
    id: 49,
    koreanQuestion:
      "우리는 권장합니다 모든 사람들, 특히 ____ 그...가지는 제한된 접근을 의료 서비스에, 취하도록 이득을 이 기회의",
    question:
      "We encourage everyone, especially ______ who have limited access to healthcare, to take advantage of this opportunity.",
    choices: {
      A: "these",
      B: "that",
      C: "them",
      D: "those",
    },
    correctAnswer: "D",
    explanation:
      '(A) these: 복수 지시대명사지만, 사람을 지칭할 때 관계대명사 who와 함께 쓰는 경우에는 those가 일반적입니다. 문법상 부자연스럽습니다.\n\n(B) that: 단수 지시대명사로, who have와 수가 일치하지 않습니다.\n\n(C) them: 목적격 대명사로, who가 선행사를 꾸며야 하는 자리에는 부적절합니다.\n\n(D) those: 복수 지시대명사로, who have와 자연스럽게 연결되며 "그러한 사람들"이라는 의미로 정확합니다.',
    translation:
      "우리는 모든 사람들, 특히 의료 서비스에 대한 접근이 제한적인 그러한 사람들이 이 기회를 활용하도록 권장합니다.",
    type: "article",
  },
  {
    id: 50,
    koreanQuestion:
      "회사는 인용했다 증가된 운송 그리고 원자재 비용을 ______ 이유로 변경 사항에 대한",
    question:
      "The company cited increased transportation and raw material costs as ______ reasons for the changes.",
    choices: {
      A: "sudden",
      B: "minor",
      C: "key",
      D: "colorful",
    },
    correctAnswer: "C",
    explanation:
      "(A) sudden(갑작스러운): 이유의 성격을 설명하긴 하나, 문맥상 핵심적인 이유를 강조하는 데 적합하지 않습니다.\n\n(B) minor(사소한): 변화의 주된 이유라는 문맥과 반대되는 의미로 부적절합니다.\n\n(C) key(핵심적인, 중요한): 회사가 변경 사항의 중요한 이유로 언급한 것과 일치하므로 정답입니다.\n\n(D) colorful(화려한): 비용이나 이유를 설명하는 데 의미적으로 적절하지 않습니다.",
    translation:
      "회사는 변경 사항에 대한 핵심적인 이유로 증가된 운송 및 원자재 비용을 인용했다.",
    type: "article",
  },
];
